"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserPointerExpression = void 0;
const typeParser_1 = require("../typeParser");
const parserPointerExpression = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        constructor() {
            super(...arguments);
            this.typeParser = new typeParser_1.TypeParser();
        }
        visitPointer(ctx) {
            return {
                type: 'Identifier',
                name: ctx.IDENTIFIER().text,
                isPointer: true
            };
        }
        visitPointerDeclarationExpression(ctx) {
            const pointer = ctx.pointer();
            const type = this.typeParser.visit(pointer._idType);
            return {
                type: 'PointerDeclarationExpression',
                pointer: this.visitPointer(pointer),
                pointerType: type
            };
        }
        visitPointerDereferenceExpression(ctx) {
            return this.visit(ctx.pointerDerefernce());
        }
        visitPointerDerefernce(ctx) {
            const identifier = {
                type: 'Identifier',
                name: ctx.IDENTIFIER().text,
                isPointer: true
            };
            return {
                type: 'UnaryExpression',
                operator: '*',
                argument: identifier
            };
        }
        visitPointerReferenceExpression(ctx) {
            return this.visit(ctx.pointerReference());
        }
        visitPointerReference(ctx) {
            const identifier = {
                type: 'Identifier',
                name: ctx.IDENTIFIER().text,
                isPointer: undefined //can't tell from & whether u are referencing pointer or variable
            };
            return {
                type: 'UnaryExpression',
                operator: '&',
                argument: identifier
            };
        }
    };
    return DerivedClass;
};
exports.parserPointerExpression = parserPointerExpression;
//# sourceMappingURL=pointerParser.js.map